<nb-card *ngIf="lista.length !== 0">
  <nb-card-body>
    <div class="row mb-2">
      <div class="col-12">
        <h4 class="titulo">Historial {{ field.displayEntidad }}</h4>
      </div>
      <div class="col-12">
        <nb-card class="bg-dark border-0">
          <nb-card-body class="p-0">
            <div class="row mx-4 header-row">
              <div
                class="col-2 align-self-center header-cell text-white text-center"
              >
                <b>Usuario</b>
              </div>
              <div
                class="col-2 align-self-center header-cell text-white text-center"
              >
                <b>Fecha</b>
              </div>
              <div
                class="col-4 align-self-center header-cell text-white text-center"
              >
                <b>Valores Nuevos</b>
              </div>
              <div
                class="col-4 align-self-center header-cell text-white text-center"
              >
                <b>Valores Viejos</b>
              </div>
            </div>
            <div class="row mx-4 table-row" *ngFor="let each of lista">
              <div
                [hidden]="hidden(each)"
                class="col-2 align-self-center header-cell text-white text-nowrap text-center"
              >
                <p class="text-center text-wrap">{{ each.usuario }}</p>
              </div>
              <div
                [hidden]="hidden(each)"
                class="col-2 align-self-center header-cell text-white text-nowrap text-center"
              >
                <p class="text-center text-wrap">
                  {{ each.fecha | date: "dd/MM/yyyy HH:mm" }}
                </p>
              </div>
              <div
                [hidden]="hidden(each)"
                class="col-4 align-self-center header-cell text-white"
              >
                <p style="white-space: pre-line">
                  {{ each.valoresModificados }}
                </p>
              </div>
              <div
                [hidden]="hidden(each)"
                class="col-4 align-self-center header-cell text-white"
              >
                <p style="white-space: pre-line">
                  {{ each.valoresAntiguos }}
                </p>
              </div>
            </div>
          </nb-card-body></nb-card
        >
      </div>
    </div>
  </nb-card-body>
</nb-card>
